// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["pricing/style-index"], () => (__webpack_require__("./gutenberg/blocks/pricing/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
